import ModulePortfolio from './modules/module-portfolio/init';

if (document.querySelector('.module-portfolio')) {
	ModulePortfolio.finalize();
}
